import {
  COMPONENT_HIERARCHY_PADDING,
  INCOMING_SUFFIX,
  LEVEL_HEADER_CELL_HORIZONTAL_PADDING,
  OUTGOING_SUFFIX,
} from '../consts';
import { canvasLabelMeasurer } from '@ardoq/graph-labeling';

export const REFERENCE_INDICATOR_WIDTH = 16;

/** Inter body font — component matrix level headers inherit font-family from the document. */
const COMPONENT_MATRIX_LABEL_FONT =
  '400 14px/20px Inter, -apple-system, Segoe UI, Roboto, Noto Sans, Ubuntu, Cantarell, Helvetica Neue';
export const measureLabel = canvasLabelMeasurer(COMPONENT_MATRIX_LABEL_FONT);
export const measureLevelLabel = (text: string) => {
  if (text === COMPONENT_HIERARCHY_PADDING) {
    return 0;
  }
  const isReference =
    text.endsWith(OUTGOING_SUFFIX) || text.endsWith(INCOMING_SUFFIX);
  const textToMeasure = isReference
    ? text.slice(0, -OUTGOING_SUFFIX.length)
    : text;
  const width = measureLabel(textToMeasure);
  if (width === 0) {
    return 0;
  }
  return (
    width +
    2 * LEVEL_HEADER_CELL_HORIZONTAL_PADDING +
    (isReference ? REFERENCE_INDICATOR_WIDTH : 0)
  );
};
